export default "__VITE_ASSET__CXawkkVc__"